
      import QuestionCircle from './question-circle.vue'
      import type { App, Plugin } from 'vue'

      export const QuestionCirclePlugin: Plugin = {
        install(app: App) {
          app.component('QuestionCircle', QuestionCircle)
        },
      }
      export { QuestionCircle }
      